<template>
    <div class="rfq" >
<!--        <el-card >-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>审核配置</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>审批列表</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="公司名称" prop="companyId">
                        <el-select v-model="searchForm.companyId"  placeholder="公司名称" size="mini"  style="width: 300px" clearable>
                            <el-option
                                    v-for="item in companys"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="用户邮箱">
                        <el-input v-model="searchForm.email" placeholder="用户邮箱" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="收货人">
                        <el-input v-model="searchForm.consignee" placeholder="收货人" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="收货人手机">
                        <el-input v-model="searchForm.mobile" placeholder="收货人手机" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="收货地址">
                        <el-input v-model="searchForm.address" placeholder="收货地址" size="mini" clearable></el-input>
                    </el-form-item>
                    <!--                    <el-form-item label="订单编号">-->
                    <!--                        <el-input v-model="searchForm.orderBatch" placeholder="订单编号" size="mini" clearable></el-input>-->
                    <!--                    </el-form-item>-->
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" placeholder="状态" size="mini" multiple clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="待下单" value="0"></el-option>
                            <el-option label="已下单" value="2"></el-option>
                            <el-option label="已发货" value="3"></el-option>
                            <el-option label="已取消" value="5"></el-option>
                            <el-option label="已驳回" value="6"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table
                        stripe
                        ref="dataTable"
                        :data="tableData"
                        size="mini"
                        v-loading="loading"
                        @selection-change="handleSelectionChange"
                        :height="tableConfig.height"
                        style="width: 100%">
                    <el-table-column type="selection" width="55"/>
                    <el-table-column
                            prop="email"
                            label="用户邮箱" width="200">
                    </el-table-column>
                    <el-table-column
                            prop="consignee"
                            label="收货人" width="120">
                    </el-table-column>
                    <el-table-column
                            prop="mobile"
                            label="收货人手机" width="120">
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            label="收货地址" width="300">
                    </el-table-column>
                    <el-table-column
                            prop="itemNum"
                            label="商品种类数量" width="150" align="center">
                    </el-table-column>
                    <!--                    <el-table-column-->
                    <!--                        prop="orderBatch"-->
                    <!--                        label="订单编号" width="120">-->
                    <!--                    </el-table-column>-->
                    <el-table-column
                            prop="totalUntaxedPrice"
                            label="未税总价(元)"
                            width="150"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="totalPrice"
                            label="报价总价(元)"
                            width="150"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="createTime"
                            label="创建时间" width="200" align="center">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            prop="status"
                            label="状态"
                            width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status == 0">待下单</el-tag>
                            <el-tag v-if="scope.row.status == 2">已下单</el-tag>
                            <el-tag v-if="scope.row.status == 3">已发货</el-tag>
                            <el-tag v-if="scope.row.status == 4">已收货</el-tag>
                            <el-tag v-if="scope.row.status == 5">已取消</el-tag>
                            <el-tag v-if="scope.row.status == 6">已驳回</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="250" align="right" fixed="right">
                        <template slot="header">
                            <el-button type="primary" size="mini" @click="exportOrderDialogNew()">导出</el-button>

                        </template>
                        <template slot-scope="scope">
                            <el-button type="text"
                                    size="mini"
                                    @click="handleToReviewDetail(scope.row)">详情</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button
                                    size="mini" type="text"
                                    @click="handleToReviewDetail2(scope.row)">审核记录</el-button>

                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                            background
                            layout="sizes,prev, pager, next"
                            :page-sizes="[10, 20, 50, 100]"
                            v-if="total>0"
                            :total="total"
                            :page-size="pageSize"
                            @size-change="handleSizeChange"
                            @current-change="onPageChange"
                            :current-page="currentPage"
                            @prev-click="onPageChange"
                            @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>

        <el-dialog title="" :visible.sync="reviewVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="reviewForm" :model="reviewForm" :rules="rules" label-width="100px">
                <el-form-item label="审核结果" prop="pass"  v-if="false">
                    <el-select v-model="reviewForm.pass" placeholder="" clearable>
                        <el-option label="通过" value="true"></el-option>
                        <el-option label="拒绝" value="false"></el-option>

                    </el-select>
                </el-form-item>
                <el-form-item label="驳回原因" prop="reason" v-if='reviewForm.pass == "false"'>
                    <el-input v-model="reviewForm.reason" placeholder="请输入驳回原因" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="reviewVisible = false">取 消</el-button>
                <el-button type="primary" @click="addProcess()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { downloadByPost, convertRes2Blob } from '../../utils/download.js';
    import { KeepAliveTableMixins } from '../../mixin/KeepAliveTable';

    const HEIGHT_OFFSET = 118;
    export default {
        mixins: [KeepAliveTableMixins],
        data() {
            return {
                pageLoading: undefined,
                tableConfig: {
                    height: 0,
                },
                reviewVisible:false,
                companys:[],
                searchForm: {
                    companyId: "",
                    email: "",
                    consignee: "",
                    address: "",
                    orderBatch: "",
                    status: "",
                },
                loading: false,
                total: 0,
                pageSize: 10,
                currentPage: 1,
                tableData: [],
                addOrderVisible: false,
                addOrderForm: {
                    id: "",
                    orderBatch: "",
                },

                exportOrderForm: {
                    orderBatch: "",
                },

                orderForm: {
                    orderBatch: "",
                },
                reviewForm: {
                    name:"",//收货人
                    pass:true,
                    reason: "",
                    workflowId:"",
                    step:"",
                    orderId:"",
                    totalPrice:""

                },
                selectData:[],//选中的数据
                rules: {
                    orderBatch: [
                        { required: true, message: '请输入订单编号', trigger: 'blur' }
                    ],
                },
            }
        },
        methods: {
            onSearch() {
                this.loading = true;
                this.selectData = [];
                let _this = this
                let cond = {...this.searchForm};
                if(!this.searchForm.status) {
                    cond['status'] = undefined;
                }
                this.$axios.post("/admin/rfq/searchReviewList",{
                    cond,
                    page: this.currentPage - 1,size:this.pageSize
                }).then(function(response) {
                    let resp = response.data;
                    if( resp.header.status == 0) {
                        _this.loading = false;

                        if(resp.data == undefined){
                            _this.tableData = [];
                            _this.total = 0;
                        }else{
                            _this.tableData = resp.data.content;
                            _this.total = resp.data.totalElements;
                        }
                    }
                }).catch(function() {
                });
            },

            addOrder() {
                const that = this;
                this.$refs.addOrderForm.validate(valid => {
                    if(valid) {
                        this.$axios.post("/admin/rfq/addRfqToCart", this.addOrderForm)
                            .then(function (response) {
                                let resp = response.data;
                                if (resp.header.status == 0) {
                                    that.$notify({
                                        title: '成功',
                                        message: '数据保存成功',
                                        type: 'success'
                                    });
                                    that.addOrderVisible = false;
                                    that.onSearch();
                                } else {
                                    that.$notify.error({
                                        title: '错误',
                                        message: resp.header.msg
                                    });
                                }
                            });
                    }
                });
            },



            passIt(orderId,step,workflowId,name,totalPrice){
                this.reviewForm.pass = 'true';
                this.reviewForm.reason = '';
                this.reviewForm.orderId = orderId;
                this.reviewForm.step = step;
                this.reviewForm.workflowId = workflowId;
                this.reviewForm.name = name;
                this.reviewForm.totalPrice = totalPrice;
                this.addProcess();
            },
            showReviewDialog(orderId,step,workflowId,name,totalPrice) {//打开审核对话框
                this.reviewForm.pass = 'false';
                this.reviewForm.reason = '';
                this.reviewForm.orderId = orderId;
                this.reviewForm.step = step;
                this.reviewForm.workflowId = workflowId;
                this.reviewForm.name = name;
                this.reviewForm.totalPrice = totalPrice;
                this.reviewVisible = true;

            },
            addProcess() {//添加审核过程
                // step,pass,orderId,WorkflowId,reason


                //确定通过abc提交的总价￥123,456,78的订单吗?

                const that = this;
                let cond = {...this.reviewForm};
                let optate = "通过";
                optate = cond.pass == 'false' ? "驳回" : "通过";
                this.$confirm('确定' + optate +'【' +cond.name+'】提交的总价【￥'+cond.totalPrice+'】的订单吗？', '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确认',
                    cancelButtonText: '取消'
                }).then(() => {

                    cond.pass = cond.pass == 'true' ? true : false;
                    if (cond.pass) {
                        cond.reason = '';
                    }
                    cond={pass:cond.pass,reason:cond.reason,orderId:cond.orderId,step:cond.step
                        ,workflowId:cond.workflowId};
                    this.$axios.post("/admin/rfq/review", cond)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {

                                that.reviewVisible = false;
                                if (resp.data == true) {//审核完毕
                                    that.changeOrder(that.reviewForm.orderId);
                                    that.onSearch();
                                } else {
                                    that.$notify({
                                        title: '成功',
                                        message: '数据保存成功',
                                        type: 'success'
                                    });
                                    that.onSearch();
                                }

                            } else {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                });





            },
            changeOrder(orderId) {//修改状态为下单
                const that = this;
                this.$axios.post("/admin/rfq/reviewOver", {orderId:orderId})
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {


                            if(resp.data == true){//审核完毕
                                that.$notify({
                                    title: '成功',
                                    message: '已下单',
                                    type: 'success'
                                });


                            }

                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            },
            handleSizeChange(pageSize){
                this.pageSize = pageSize;
                this.onSearch();
            },
            onPageChange(currentPage) {
                this.currentPage = currentPage;
                this.onSearch();
            },
            handleToReviewDetail2(row) {

                this.$router.push({name: "reviewDetails", params: {from: "rfq", orderId: row.id,
                        step:row.reviewStep, workflowId:row.workflowId, name:row.consignee,totalPrice:row.totalPrice
                        ,title:"审批明细"}})


                // let that = this;
                // this.$axios.post("/admin/rfq/reviewDetail", row.id)
                //     .then(function (response) {
                //         let resp = response.data;
                //         if (resp.header.status == 0) {
                //               alert("hi");
                //
                //
                //
                //         } else {
                //             that.$notify.error({
                //                 title: '错误',
                //                 message: resp.header.msg
                //             });
                //         }
                //     });


            },
            handleToReviewDetail(row) {


                this.$router.push({name: "customerReviewDetail", params: {from: "rfq", orderId: row.id,title:"订单详情",hide:true
                       }})



            },
            handleSelectionChange(val) {
                this.selectData = val;
            },
            exportOrderDialogNew(){
                if(this.selectData.length == 0){
                    this.$message({
                        type: 'info',
                        message: '请选择要导出的订单',
                        duration: 2000
                    });
                    return;
                }
                const that = this;
                let arr = [];
                let val = this.selectData;
                if(val.length>0){
                    for(let i=0; i<val.length; i++){
                        arr.push(val[i].id);
                    }
                    downloadByPost({
                        axios: that.$axios,
                        url: "/admin/easypoi/review",
                        data: arr,
                        success: response => {
                            convertRes2Blob(response);
                        },
                    });
                }
            },
            loadCompanys(){
                let _this = this
                this.$axios.post("/admin/company/companys"
                ).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        _this.companys = resp.data;
                    }

                });

            },
            exportDeliver(){
                if(this.selectData.length == 0){
                    this.$message({
                        type: 'info',
                        message: '请选择要导出的订单',
                        duration: 2000
                    });
                    return;
                }
                const that = this;
                let arr = [];
                let val = this.selectData;
                if(val.length>0){
                    for(let i=0; i<val.length; i++){
                        arr.push(val[i].id);
                    }
                    downloadByPost({
                        axios: that.$axios,
                        url: "/admin/easypoi/deliver",
                        data: arr,
                        success: response => {
                            convertRes2Blob(response);
                        },
                    });
                }
            },
            setTableHeight() {
                const tablePosition = this.$refs['tablePosition'];
                const {top} = tablePosition.getBoundingClientRect();
                this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
            }
        },
        created() {
            this.onSearch();
            this.loadCompanys();
            window.addEventListener("resize", this.setTableHeight);
        },
        mounted() {
            this.pageLoading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(() => {
                this.setTableHeight();
                this.pageLoading.close();
                this.pageLoading = undefined;
            }, 500);
        },
        beforeDestroy() {
            if(this.pageLoading){
                this.pageLoading.close();
                this.pageLoading = undefined;
            }
        },
        destroyed () {
            window.removeEventListener("resize", this.setTableHeight);
        }
    }
</script>
